import { render, staticRenderFns } from "./addPripAcco.vue?vue&type=template&id=51ef3c83&scoped=true"
import script from "./addPripAcco.vue?vue&type=script&lang=js"
export * from "./addPripAcco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ef3c83",
  null
  
)

export default component.exports